
import $ from 'jquery'

export const EventArray = [
  'BJP Foundation Day Program',
  ' Swachh Bharat campaign',
  'Community Meal',
  'Medical Camp',
  'Awareness camp and medical camp to make tribal youth self-reliant for employment',
  'Public awareness on natural farming, foot march/Padyatra on the banks of rivers, campaign for millets',
  'Community Meal with SC women',
  'OBC Morcha`s program on the birth anniversary of Jyotirao Phule',
  'Medical camp and Swachh Bharat drive',
  'Cleaning of water reservoirs and plantation drive',
  'Baba Sahib Ambedkar`s birth anniversary programs',
  'Ayushmaan Bharat',
  'Pradhan Mantri Awas Yojna',
  'Har Ghar Nal se Jal',
  'PM Kisan scheme',
  'Jyotiba Phule Diwas',
  'Free Covid Vaccination scheme',
  'Gareeb Kalyan Ann Yojna',
  'Ambedkar Jayanti',
  'Anusuchit Janjaati Kalyaan',
  'Asangathit Shramik',
  'Vitteey Samavesh Gaurav Diwas',
  'Swachh Bharat Mission',
  'Poshan Abhiyan',
  'Azadi ka Amrit Mahotsav'
];

export const AjaxRequest = async (reqData) => {
  let Data = {
    token: "gKKZLKeV+7Qz8UpLR2loJ6/v0KyVSqbs+DI1KREOIOTkHwGWRvficfOsUa1joUPu",
    deviceid: "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a",
  };
  Data = { ...Data, ...reqData };
  var settings = {
    url: "https://api.narendramodi.in/mlapiv1",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      // "Cookie": "BJP-LB=APP02"
    },
    data: Data,
  };

  let data = await $.ajax(settings);

  return data;
};


export const AjaxRequestForConstituency = async (reqData) => {
  let Data = {
    token: "gKKZLKeV+7Qz8UpLR2loJ6/v0KyVSqbs+DI1KREOIOTkHwGWRvficfOsUa1joUPu",
    deviceid: "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a",
  };
  Data = { ...Data, ...reqData };
  var settings = {
    url: "https://api.narendramodi.in/apiv2",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      // "Cookie": "BJP-LB=APP02"
    },
    data: Data,
  };

  let data = await $.ajax(settings);

  return data;
};

export const AjaxRequestForEvents = async (reqData) => {
    let Data = {
        token:"T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga"
    };
    Data = { ...Data, ...reqData };
    var settings = {
      url: "https://ew.narendramodi.in/api",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: Data,
    };
  
    let data = await $.ajax(settings);
    return data;
  };

export const getResponse = async (url, data) => {

  var datas = {};
  datas = data;
  datas["token"] = "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga";
  datas["addressid"] = "";
  var request = await $.ajax({
    url: "https://ew.narendramodi.in/api" + url,
    data: datas,
    method: "post"
  });
  //all value in resp.data for list.
  return request;

};

export const dataURLToBlob = function (dataURL) {
  var BASE64_MARKER = ";base64,";
  var parts = "";
  var contentType = "";
  var raw = "";
  if (dataURL.indexOf(BASE64_MARKER) === -1) {
    parts = dataURL.split(",");
    contentType = parts[0].split(":")[1];
    raw = parts[1];
    return new Blob([raw], { type: contentType });
  }
  parts = dataURL.split(BASE64_MARKER);
  contentType = parts[0].split(":")[1];
  raw = window.atob(parts[1]);
  var rawLength = raw.length;
  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
};

export const checkMobile = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    return "mobile";
  } else {
    return "desktop";
  }
};

export const appShareTextString = (text) => {
  // text = text ? text.split("'").join("") : "";
  text = text ? text.split("‘").join("'") : "";
  text = text ? text.split("’").join("'") : "";
  text = text ? text.split("‟").join('"') : "";
  text = text ? text.split("“").join('"') : "";
  text = text ? text.split("❝").join('"') : "";
  text = text ? text.split("❞").join('"') : "";
  text = text ? text.split("”").join('"') : "";
  text = text ? text.split("„").join('"') : "";
  return text;
};

export const apiUrl = 'https://campaign-api.narendramodi.in/';
export const apiUrlRDS = 'https://campaign-api.narendramodi.in/mahila-rds';

export const doRequest = (payload, sync, urlType = 'default') => {
  var data = JSON.stringify(payload);
  var xhr = new XMLHttpRequest();
  let url = urlType === 'RDS' ? apiUrlRDS : apiUrl + 'beneficiary_2023';
  xhr.open("POST", url, sync);
  xhr.send(data);
  return xhr;
};

export const parseURLParams = (url) => {
  var queryStart = url.indexOf("?") + 1,
    queryEnd = url.indexOf("#") + 1 || url.length + 1,
    query = url.slice(queryStart, queryEnd - 1),
    pairs = query.replace(/\+/g, " ").split("&"),
    parms = {},
    i,
    n,
    v,
    nv;

  if (query === url || query === "") return;

  for (i = 0; i < pairs.length; i++) {
    nv = pairs[i].split("=", 2);
    n = decodeURIComponent(nv[0]);
    v = decodeURIComponent(nv[1]);

    if (!parms.hasOwnProperty(n)) parms[n] = [];
    parms[n].push(nv.length === 2 ? v : null);
  }
  return parms;
};